import type { TFunction } from 'i18next';

import { roleGroupLabel } from '../../../close-the-loop';
import type { HearLine, RoleGroup } from '../../../close-the-loop';
import type { PlantScope } from '../../domain/hearLines';

export const hearLineText = (t: TFunction, line: HearLine): string => {
  switch (line) {
    case 'ISSUES_AND_TASKS':
      return t('onboarding.hear.line.issuesAndTasks', 'Every Issue and Task at the plant');
    case 'NOT_STARTED_REMINDERS':
      return t('onboarding.hear.line.notStarted', 'Reminders when nothing has started');
    case 'HANDED_TO_YOU':
      return t('onboarding.hear.line.handedToYou', 'Anything handed to you');
    case 'ISSUES_AND_REMINDERS':
      return t('onboarding.hear.line.issuesAndReminders', 'Every Issue at the plant, and every reminder');
    case 'APPROVALS_HANDOFFS_HELP':
      return t('onboarding.hear.line.approvalsHandoffsHelp', 'Approvals waiting, hand-offs, help requests');
    case 'OPERATOR_TURNS_DOWN':
      return t('onboarding.hear.line.operatorTurnsDown', 'When an Operator turns alerts down');
    case 'EMERGENCIES_AT_ONCE':
      return t('onboarding.hear.line.emergencies', 'Emergencies, at once');
    case 'ANYTHING_OVERDUE':
      return t('onboarding.hear.line.overdue', 'Anything overdue');
    case 'APPROVALS_OVERDUE':
      return t('onboarding.hear.line.approvalsOverdue', 'Approvals overdue');
    case 'OVERDUE_IN_MORNING_EMAIL':
      return t('onboarding.hear.line.overdueEmail', 'Anything overdue, in your morning email');
    case 'CHRONIC_IN_MORNING_EMAIL':
      return t('onboarding.hear.line.chronicEmail', 'Anything that keeps coming back, in your morning email');
  }
};

export const roleScopeText = (t: TFunction, roleGroup: RoleGroup, scope: PlantScope): string => {
  const role = roleGroupLabel(t, roleGroup);
  if (scope.first === null) return role;
  if (scope.others === 0) return t('onboarding.hear.roleScope', '{{role}} · {{plant}}', { role, plant: scope.first });
  if (scope.others === 1) {
    return t('onboarding.hear.roleScopePlantsOne', '{{role}} · {{plant}} + 1 plant', { role, plant: scope.first });
  }
  return t('onboarding.hear.roleScopePlants', '{{role}} · {{plant}} + {{count}} plants', {
    role,
    plant: scope.first,
    count: scope.others,
  });
};
